import { Component, OnInit, ViewChild } from '@angular/core';
import { NotificationService } from '@alfresco/adf-core';
import { DocumentListComponent } from '@alfresco/adf-content-services';
import { DocmentlistService } from '../../service/docmentlist.service';
import { Router } from '@angular/router';
import { AssinaturaModel } from 'app/model/assinatura/assinatura.model';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as CryptoJS from 'crypto-js';


interface Food {
  value: string;
  viewValue: string;
}

interface Type {
  value: string;
  viewValue: string;
}



@Component({
  selector: 'app-documentlist',
  templateUrl: './documentlist.component.html',
  styleUrls: ['./documentlist.component.css']
})
export class DocumentlistComponent implements OnInit {

  valorType = '';

  foods: Food[] = [
    {value: 'steak-0', viewValue: 'Steak'},
    {value: 'pizza-1', viewValue: 'Pizza'},
    {value: 'tacos-2', viewValue: 'Tacos'}
  ];

  types: Type[] = [
    {value: 'Signer', viewValue: 'Assinador'},
    {value: 'Approver', viewValue: 'Aprovador'},
    {value: 'SignRule', viewValue: 'Visualizador'}
  ];

  public loading = false;

  assinatura = {} as AssinaturaModel;
  assinaturas: AssinaturaModel[];
  orderForm: FormGroup;
  signer: FormArray;
  documentListP = true;
  public arrayString: string;


  showViewer: Boolean = false;
  nodeId: String = null;
  submit = false;

  @ViewChild(DocumentListComponent)
  documentList: DocumentListComponent;

  constructor(private notificationService: NotificationService,
    private documetService: DocmentlistService,
    private route: Router,
    private formBuilder: FormBuilder
    ) {
  }



  ngOnInit() {
    this.getAuthority();
    if(this.documentListP === false) {
      this.route.navigate(['403']);
    }
    this.orderForm = this.formBuilder.group({
      user : 'admin',
      company : '12-123',
      useSteps : false,
      nodes: AssinaturaModel,
      signer: this.formBuilder.array([ this.createItem() ])
    });
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      type: ['', [Validators.required]],
      name: ['', Validators.required],
      cpf: ['', [Validators.required]],
      email: ['', [Validators.required]],
      signer: [false, [Validators.required]]
    });
  }

  onSubmit(){
    this.submit = true;
  }

  addItem(): void {
    this.signer = this.orderForm.get('signer') as FormArray;
    this.signer.push(this.createItem());
  }

  remover(indice: any){
    if(indice > 0){
      this.signer.removeAt(indice);
    }else{
      alert("Não é permitido remover o primeiro participante");
    }

  }



  solicitar(){

    this.orderForm.get('nodes').setValue(this.assinaturas);

    let enviar = true;
    this.orderForm.get('signer').value.forEach(element => {
      console.log(element)
      if(!element.type || !element.name || !element.cpf ){
        enviar = false;
      }
    });

    if(this.orderForm.get('nodes').value.length < 1){
      alert('Nenhum documento selecionado');
      enviar = false;
    }

    if(enviar){
      this.loading = true;
      this.documetService.postDoc(this.orderForm.value).subscribe( retorno => {
        alert('Solicitação enviada com sucesso! ');
       this.loading = false;
        this.route.navigate(['/home']);
      }, error => {
         console.log(error.error)
         alert(error.error);
         this.loading = false;
      });

    }


  }

  uploadSuccess(event: any) {
    this.notificationService.openSnackMessage('File uploaded');
    this.documentList.reload();
  }

  showPreview(event) {

    this.showViewer = false;
    if (event.value.entry.isFile) {
      this.nodeId = event.value.entry.id;
      this.showViewer = true;
    }
  }

  onGoBack(event: any) {
    this.showViewer = false;
  }

  myCustomAction1(element){
    let s = new Array<AssinaturaModel>();

    if(element.entry.isFile && element.entry.content.mimeType && element.entry.content.mimeType == "application/pdf"){

      this.assinatura = new AssinaturaModel();
      this.assinatura.uuid = element.entry.id;
      this.assinatura.isFile = element.entry.isFile;
      this.assinatura.mimeType = element.entry.content.mimeType;
      this.assinatura.name = element.entry.name;
      s.push(this.assinatura);

    }

    this.assinaturas = s;

  }

  myCustomAction2(event: any){
    let s = new Array<AssinaturaModel>();
    event.forEach(element => {

      if(element.entry.isFile && element.entry.content.mimeType && element.entry.content.mimeType == "application/pdf"){

          this.assinatura = new AssinaturaModel();
          this.assinatura.uuid = element.entry.id;
          this.assinatura.isFile = element.entry.isFile;
          this.assinatura.mimeType = element.entry.content.mimeType;
          this.assinatura.name = element.entry.name;
          s.push(this.assinatura);

      }

    });
    this.assinaturas = s;
    if(this.assinaturas.length < 1){
      alert("Nenhum arquivo PDF selecionado");
    }
    //($('#exampleModal') as any).modal('show');
    /*$("#exampleModal").modal("show");*/

    /*
    this.documetService.postDoc(assinaturas).subscribe( assinaturas2 => {
      this.route.navigate(['sign', assinaturas]);
    }, error => {
      console.error(error);
    });*/

  }

  changed(event, posicao){
    //console.log(event)
    /*console.log(posicao)
    this.valorType = this.orderForm.get('signer').value[posicao].email;
    console.log(this.orderForm.controls["signer"])
    console.log(this.valorType);*/
  }

  getAuthority() {
    this.getItemAuthority('authority');
      if (this.arrayString.includes('DOCUMENT_LIST') || this.arrayString.includes('SUPER_USER')) {
        this.documentListP = true;
      } else {
        this.documentListP = false;
      }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
        try {
            const bytes = CryptoJS.AES.decrypt(store, sessionStorage.getItem('ticket-ECM'));
            this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            return this.arrayString;
        } catch (e) {
            sessionStorage.clear();
        }
    }

    return null;
  }






}



// WEBPACK FOOTER //
// /app/src/app/components/documentlist/documentlist.component.ts